import { h, ComponentChildren, ComponentChild } from 'preact'
import Icon from '../../assets'

interface Props {
  children: ComponentChildren
  onClose?: () => void
  variant?: 'S' | 'M' | 'L'
  isControl?: boolean
}

interface ModalHeaderProps {
  icon?: string
  title: string|ComponentChild
}

interface ModalBodyProps {
  children: ComponentChildren
}

interface ModalFooterProps {
  children: ComponentChildren
}

export const ModalHeader = ({ title }: ModalHeaderProps) => (
  <div className='m-modal--header'>
    <h3 className='m-modal--header_title'><strong>{title}</strong></h3>
  </div>
)

export const ModalFooter = ({ children }: ModalFooterProps) => (
  <div className='m-modal--footer'>{children}</div>
)

export const ModalBody = ({ children }: ModalBodyProps) => (
  <div className='m-modal--body'>{children}</div>
)

const Modal = ({ children, onClose, variant = 'M', isControl = false }: Props) => (
  <div className='o-modal_container'>
    <div className='o-modal--opacity' />
    <div className={`o-modal o-modal--size-${variant} o-modal--app-${isControl ? 'control' : 'destination'}`}>
      <span onClick={onClose}><Icon icon='close' width={24} height={24} color='currentColor' customClass='o-modal--close' /></span>
      {children}
    </div>
  </div>
)

export default Modal
